<template>
    <div class="manage-roles">
        <ns-loader
            :toLoad="[{
                model: 'users',
                name: 'users',
            }]"
            @dataFetched="onDataFetched"
            @dataError="onDataError"
        >
            <template slot="content">

                <el-button
                    type="primary"
                    style="display: flex; margin-left: auto;"
                    icon="el-icon-plus"
                    @click="openRoleModal(null)"
                >{{ getVerbose('permissions_role_creation_button') }}</el-button>
                <el-table
                    :data="$store.getters.concreteRoles"
                    style="width: 100%"
                >
                    <el-table-column
                        :label="getVerbose('permissions_role_table_column_name')"
                        prop="name"
                    >
                    </el-table-column>
                    <el-table-column
                        :label="getVerbose('permissions_role_table_column_actions')"
                    >
                        <template slot-scope="scope">
                            <el-button
                                type="primary"
                                icon="el-icon-delete"
                                @click="deleteRole(scope.row)"
                            ></el-button>
                            <el-button
                                type="primary"
                                icon="el-icon-edit"
                                @click="openRoleModal(scope.row)"
                            ></el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </template>
        </ns-loader>
        <role-modal ref="roleModal" :user-list="userList" @save-role="saveRole"></role-modal>

    </div>
</template>

<script>
import NsLoader from '../partials/ns-vue-loader';
import NsPaginate from '../partials/nsPaginate';
import ListRole from './list-roles.vue';
import RoleModal from './role-modale.vue';
import {mapGetters} from 'vuex';
export default {
    components: {
        ListRole,
        NsLoader,
        NsPaginate,
        RoleModal,
    },
    props: {},
    data() {
        return {
            userList: [],
        };
    },
    computed: {
        ...mapGetters('fundation', [
            'getVerbose',
            'currentLang',
        ])

    },
    mounted() {},
    methods: {
        saveRole(role) {
            let action = role.uid ? 'patchItem' : 'createItem';
            let url = this.$store.state.api.meta.listModels.concreteRoles.url;
            this.$store.dispatch(action, {
                item: role,
                url: url,
                model: 'concreteRoles',
            }).then((response) => {
                this.$notify.success({
                    title: this.getVerbose('permissions_role_save_successfull_title'),
                    message: `${this.getVerbose('permissions_role_save_successfull_message_role')} '${response.name}' ${role.uid ? this.getVerbose('permissions_role_save_successfull_message_edited') : this.getVerbose('permissions_role_save_successfull_message_created')}`
                });
                this.$refs.roleModal.close();
            }).catch(() => {
                if (this.currentLang === 'fr') {
                    this.$notify.error({
                        title: this.getVerbose('permissions_role_save_failed_title'),
                        message: `${role.uid ? this.getVerbose('permissions_role_save_failed_message_edited') : this.getVerbose('permissions_role_save_failed_message_created')} ${this.getVerbose('permissions_role_save_failed_message_role')}`
                    });
                }
                else if (this.currentLang === 'en') {
                    this.$notify.error({
                        title: this.getVerbose('permissions_role_save_failed_title'),
                        message: `${this.getVerbose('permissions_role_save_failed_message_role')} ${role.uid ? this.getVerbose('permissions_role_save_failed_message_edited') : this.getVerbose('permissions_role_save_failed_message_created')}`
                    });
                }
            });
        },
        onDataFetched(response) {
            this.$store.dispatch('fundation/updateArrayOfItems', {
                srcArray: this.userList,
                targetArray: response.users
            });
        },
        onDataError() {
            this.$notify.error(this.getVerbose('permissions_user_retrieval_error'));
        },
        openRoleModal (role){
            this.$refs.roleModal.init(role);
        },
        deleteRole (role){
            this.$confirm(this.getVerbose('permissions_role_deletion_message'), this.getVerbose('permissions_role_deletion_title'), {
                confirmButtonText: this.getVerbose('permissions_role_deletion_button_confirm'),
                cancelButtonText: this.getVerbose('permissions_role_deletion_button_cancel'),
                type: 'warning'
            }).then(() => {
                this.$store.dispatch('deleteItem', {
                    item: role,
                    model: 'concreteRoles'
                }).then(() => {
                    this.$notify.success({title: this.getVerbose('permissions_role_deletion_success_title'), message: this.getVerbose('permissions_role_deletion_success_message')});
                }).catch(() => {
                    this.$notify.error({title: this.getVerbose('permissions_role_deletion_failure_title'), message: this.getVerbose('permissions_role_deletion_failure_message')});

                });
            });
        },
    },
};

</script>
<style lang="scss">

</style>




// WEBPACK FOOTER //
// node_modules/fundation-app-vuejs/src/components/permissionsManagement/roles-and-users.vue